/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_7_AInputs */

const en_mk_faq_7_a = /** @type {(inputs: Mk_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Workspaces support members, owners, comments, and activity. Studio adds estimates, proposals, a client portal, and handover. Campus supports capstones and facilitation. Access and limits depend on your plan.`)
};

const id_mk_faq_7_a = /** @type {(inputs: Mk_Faq_7_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisa. Workspace mendukung anggota, penanggung jawab, komentar, dan aktivitas. Studio menambahkan estimasi, proposal, portal klien, dan serah terima. Program Kampus mendukung capstone dan fasilitasi. Akses dan batasnya mengikuti paket.`)
};

/**
* | output |
* | --- |
* | "Yes. Workspaces support members, owners, comments, and activity. Studio adds estimates, proposals, a client portal, and handover. Campus supports capstones a..." |
*
* @param {Mk_Faq_7_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_7_a = /** @type {((inputs?: Mk_Faq_7_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_7_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_7_a(inputs)
	return en_mk_faq_7_a(inputs)
});